import { apiJson, apiJsonArray } from '@/lib/api-client';

export interface Notification {
  id: number;
  user_id: number;
  type:
    | 'booking_request'
    | 'booking_confirmed'
    | 'booking_cancelled'
    | 'booking_rejected'
    | 'message_received'
    | 'system_announcement'
    | 'general_info';
  title: string;
  message: string;
  is_read: boolean;
  related_entity_type: 'booking' | 'message' | 'property' | 'system';
  related_entity_id: number;
  created_at: string;
  read_at: string | null;
}

export class NotificationService {
  static async createNotification(
    userId: number,
    type: Notification['type'],
    title: string,
    message: string,
    relatedEntityType: Notification['related_entity_type'],
    relatedEntityId: number,
  ): Promise<Notification> {
    throw new Error(
      'createNotification deve ser feito no servidor; use endpoints espec�ficos.',
    );
  }

  static async getNotificationById(id: number): Promise<Notification> {
    throw new Error('Use listForUser');
  }

  static async getUserNotifications(
    userId: number,
    limit: number = 50,
  ): Promise<Notification[]> {
    return apiJsonArray<Notification>(
      `api/notifications?limit=${limit}`,
    );
  }

  static async markAsRead(
    notificationId: number,
    userId: number,
  ): Promise<boolean> {
    const r = await apiJson<{ success: boolean }>(
      `api/notifications/${notificationId}/read`,
      { method: 'PATCH' },
    );
    return r.success;
  }

  static async markAllAsRead(userId: number): Promise<boolean> {
    const r = await apiJson<{ success: boolean }>(
      'api/notifications/read-all',
      { method: 'PATCH' },
    );
    return r.success;
  }

  static async getUnreadCount(userId: number): Promise<number> {
    const r = await apiJson<{ count: number }>(
      'api/notifications/unread-count',
    );
    return r.count;
  }

  static async deleteNotification(
    notificationId: number,
    userId: number,
  ): Promise<boolean> {
    const r = await apiJson<{ success: boolean }>(
      `api/notifications/${notificationId}`,
      { method: 'DELETE' },
    );
    return r.success;
  }

  static async getNotifications(
    userId: number,
    limit: number = 50,
  ): Promise<Notification[]> {
    return this.getUserNotifications(userId, limit);
  }

  static async createMessageReceivedNotification(
    userId: number,
    senderName: string,
    propertyTitle: string,
    messageId: number,
  ): Promise<Notification> {
    throw new Error('Criado no servidor ao enviar mensagem.');
  }
}
